import { EventEmitter } from 'events';
import { v4 as uuidv4 } from 'uuid';

const Constants = {
  CHANGE: 'change',
};

class WpToastManager extends EventEmitter {
  constructor() {
    super();
    this.toasts = [];

    this.addToast = this.addToast.bind(this);
    this.setToasts = this.setToasts.bind(this);
    this.removeToast = this.removeToast.bind(this);
    this.buildToast = this.buildToast.bind(this);
    this.emitChange = this.emitChange.bind(this);
  }

  setToasts(newToasts) {
    this.toasts = newToasts;
    this.emitChange();
  }

  buildToast(message, toastOptions) {
    return { message, uuid: uuidv4(), createdAt: Date.now(), ...toastOptions };
  }

  addToast(message, toastOptions) {
    if (message) this.setToasts([...this.toasts, this.buildToast(message, toastOptions)]);
  }

  removeToast(toastToRemove) {
    this.setToasts(this.toasts.filter(toast => toast.uuid !== toastToRemove.uuid));
    this.emitChange();
  }

  info(message, toastOptions = {}) {
    const options = { ...toastOptions, variant: 'info' };
    this.addToast(message, { options });
  }

  success(message, toastOptions = {}) {
    const options = { ...toastOptions, variant: 'success' };
    this.addToast(message, { options });
  }

  warning(message, toastOptions = {}) {
    const options = { ...toastOptions, variant: 'warning' };
    this.addToast(message, { options });
  }

  danger(message, toastOptions = {}) {
    const options = { ...toastOptions, variant: 'danger' };
    this.addToast(message, { options });
  }

  emitChange() {
    this.emit(Constants.CHANGE, this.toasts);
  }

  addChangeListener(callback) {
    this.addListener(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new WpToastManager();
